<template>
    <form action="./" autocomplete="off" autocapitalize="off" method="get" @submit.prevent="false" id="search">
        <div class="search-container" v-bind:class="{'is-large': isLarge}" @keydown.esc="citySelector = false">
            <div class="input-container">
                <div class="control place-input-container has-icons-right">
                    <div v-if="this.c !== '' " class="input is-large place-input" @click="(showCitiesInputBox = true) && (c = '')" type="text" :placeholder="$t('web.travel-activities.search-country-placeholder')" v-model="c" name="where_do_you_want_to_go" @focus="keyDownCitySelector" @keydown="keyDownCitySelector" @keydown.esc="citySelector = false" @keydown.enter="search">{{c}}</div>
                    <div v-if="this.c === '' " class="input empty-city is-large place-input" @click="showCitiesInputBox = true" type="text" :placeholder="$t('web.travel-activities.search-country-placeholder')" v-model="c" name="where_do_you_want_to_go" @focus="keyDownCitySelector" @keydown="keyDownCitySelector" @keydown.esc="citySelector = false" @keydown.enter="search">{{ $t('web.travel-activities.search-country-placeholder') }}</div>
                    <span class="icon is-small is-right"><i class="far fa-angle-down"></i></span>
                </div>
                <div class="control activity-input-container has-icons-left">
                    <input type="search" name="search" class="input is-large activity-input" :placeholder="$t('web.travel-activities.search-placeholder')" v-model="q" @keydown.enter="search" @keydown.esc.prevent.stop="cancelPredictiveSearch" @blur="cancelPredictiveSearch" @focus="resumePredictiveSearch">
                </div>

                <button class="search-button button hd-18 white bold" @click.prevent="search" v-bind:class="{'is-loading': isLoading}"><i class="fas fa-search"></i> {{ $t('web.travel-activities.search-button')}}</button>
                <div v-if="showPredictiveSearch" class="activity-select-container">
                    <div class="loader-container" v-if="!predictiveSearchesResults || predictiveSearchesResults.length == 0">
                        <span class="loader"></span>
                    </div>
                    <div class="scroll-container">
                        <ul>
                            <li v-for="predictiveSearchResult in predictiveSearchesResults">
                                <a href="#" class="hd-14" @click.prevent="selectPredictiveSearch(predictiveSearchResult)">
                                    <i class="far fa-torii-gate"></i> {{ predictiveSearchResult }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="showCitiesInputBox" class="predictive-search-container">
                <div class="country-select-container">
                    <div class="scroll-container">
                        <div class="input-container">
                            <input class="input place-input" type="search" :placeholder="$t('web.travel-activities.search-country-placeholder')" v-model="c" name="where_do_you_want_to_go" @focus="keyDownCitySelector" @keydown="keyDownCitySelector" @keydown.esc="citySelector = false" @keydown.enter="search">
                            <a @click.prevent="showCitiesInputBox = false" class="icon-container shuttle-gray600 hd-14">
                                {{ $t('web.travel-activities.search-cancel-button')}}
                            </a>
                        </div>
                        <div v-if="this.c === ''"  class="popular-city">
                            <div class="section-title gray600 hd-12">
                                {{ $t('web.travel-activities.search-popular-cities') }}
                            </div>
                            <div class="feature-cities-container">
                                <div @click="select($t('city.' + city.toLowerCase().replace(' ','-')))" v-for="city in featuredCities" class="city hm-16 hd-14">
                                    {{ $t('city.' + city.toLowerCase().replace(' ','-') ) }}
                                </div>
                            </div>
                        </div>
                        <div v-if="this.c === '' " class="all-city">
                            <div class="section-title gray600 hd-12">
                                {{ $t('web.travel-activities.search-all-cities') }}
                            </div>
                            <div class="continent-container">
                                <a v-bind:class="{'is-active': isAsiaActive}" @click="selectContinent('asia')" class="continent hm-14 hd-14 bold">{{ $t('web.travel-activities.search-asia') }}</a>
                                <a v-bind:class="{'is-active': isEuroActive}" @click="selectContinent('euro')" class="continent hm-14 hd-14 bold">{{ $t('web.travel-activities.search-euro-middleeast') }}</a>
                                <a v-bind:class="{'is-active': isAmericaActive}" @click="selectContinent('america')" class="continent hm-14 hd-14 bold">{{ $t('web.travel-activities.search-america')}}</a>
                                <a v-bind:class="{'is-active': isAfricaActive}" @click="selectContinent('africa')" class="continent hm-14 hd-14 bold">{{ $t('web.travel-activities.search-africa-oceania') }}</a>
                            </div>

                            <div v-if="isAsiaActive" v-for="(item, index) in Asia" class="cities-container">
                                <div class="country hm-16 hd-14 bold">
                                    <a @click="select($t('country.'+ index.toLowerCase().split(' ').join('-') ))">{{ $t('country.'+ index.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                                <div class="cities hm-16 hd-14">
                                    <a @click="select($t('city.' + city.toLowerCase().split(' ').join('-') ))" v-for="city in item" class="city">{{ $t('city.' + city.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                            </div>

                            <div v-if="isEuroActive" v-for="(item, index) in Europe_MiddleEast" class="cities-container">
                                <div class="country hm-16 hd-14 bold">
                                    <a @click="select($t('country.'+ index.toLowerCase().split(' ').join('-') ))">{{ $t('country.'+ index.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                                <div class="cities hm-16 hd-14">
                                    <a @click="select($t('city.' + city.toLowerCase().split(' ').join('-') ))" v-for="city in item" class="city">{{ $t('city.' + city.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                            </div>

                            <div v-if="isAmericaActive" v-for="(item, index) in America" class="cities-container">
                                <div class="country hm-16 hd-14 bold">
                                    <a @click="select($t('country.'+ index.toLowerCase().split(' ').join('-') ))">{{ $t('country.'+ index.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                                <div class="cities hm-16 hd-14">
                                    <a @click="select($t('city.' + city.toLowerCase().split(' ').join('-') ))" v-for="city in item" class="city">{{ $t('city.' + city.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                            </div>

                            <div v-if="isAfricaActive" v-for="(item, index) in Africa_Oceania" class="cities-container">
                                <div class="country hm-16 hd-14 bold">
                                    <a @click="select($t('country.'+ index.toLowerCase().split(' ').join('-') ))">{{ $t('country.'+ index.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                                <div class="cities hm-16 hd-14">
                                    <a @click="select($t('city.' + city.toLowerCase().split(' ').join('-') ))" v-for="city in item" class="city">{{ $t('city.' + city.toLowerCase().split(' ').join('-') ) }}</a>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.c != '' " class="predictive-search">
                            <div class="section-title gray600 hd-12">
                                {{ $t('web.travel-activities.search-searched-cities') }}
                            </div>
                            <div class="loader-container" v-if="(!filteredCities || filteredCities.length == 0) && !showNoPlace">
                                <span class="loader"></span>
                            </div>
                            <ul>
                                <li v-for="city in filteredCities">
                                    <a class="hm-16 hd-14" @click.prevent="selectCity(city.slug)">
                                        <i class="fas fa-map-marker-alt" v-if="city.type == 'city'"></i>
                                        <i class="fas fa-globe" v-else></i>
                                        {{ city.name }}
                                    </a>
                                </li>
                                <li v-if="showNoPlace" class="no-this-place-container">
                                    <p class="hm-16 hd-14">{{ $t('web.travel-sims.country-search-no-place-found') }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popular-search-container">
            <div class="popular-search">{{ $t('web.travel-activities.search-hardcoded-cities') }}</div>
            <div class="popular-search-cities">
                <div v-for="hardcoded_city in hardcoded_cities">
                    <a @click.prevent="searchPopularSearch($t('city.' + hardcoded_city.toLowerCase().split(' ').join('-')))">{{ $t('city.' + hardcoded_city.toLowerCase().split(' ').join('-')) }}</a>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    const throttle = require('lodash/throttle');
    export default {
        props: {
            apiDomain: String,
            isLarge: Boolean,
            city: String,
            search_keyword: String,
            locale: String,
            hardcoded_cities: Array,
        },

        data(){
            return {
                q: "",
                c: "",
                isAsiaActive: true,
                isEuroActive: false,
                isAmericaActive: false,
                isAfricaActive: false,
                citySelector: false,
                showNoPlace: false,
                showCitiesInputBox: false,
                filteredCities: [],
                predictiveSearchesResults: [],
                showPredictiveSearch: false,
                lastPredictiveSearchQ: "",
                isLoading: false,
                featuredCities: ['Hong Kong', 'Macao', 'Taipei', 'Singapore','Seoul','Shanghai','Beijing','Tokyo','Osaka','Kyoto','Bangkok','Phuket','Bali','London','Paris','New York' ],
                Asia: {
                    "Japan":["Osaka","Tokyo","Hokkaido","Kyoto","Okinawa" , "Kyushu", "Fukuoka","Nagoya","Hiroshima", "Okayama"],
                    "Taiwan":["Taipei","Yilan","Hualien","Taitung","Taichung","Kaohsiung","Kenting","Tainan"],
                    "South-Korea":["Seoul","Jeju","Busan","Gangwon-do","Gyeonggi-do","Incheon"],
                    "Thailand":["Bangkok","Pattaya","Chiang Mai","Phuket","Krabi","Hua Hin","Chiang Rai"],
                    "China":["Guangdong","Beijing","Shanghai","Suzhou","Hangzhou","Chengdu","Guilin","Zhangjiajie","Yunnan","Xiamen","Chongqing"],
                    "Hong Kong":["Hong Kong"],
                    "Macau":["Macao"],
                    "Singapore":["Singapore"],
                    "Malaysia":["Kuala Lumpur","Sabah","Langkawi","Ipoh"],
                    "Indonesia":["Bali"],
                    "Philippines":["Manila","Boracay","Cebu","Palawan"],
                    "Vietnam":["Ho Chi Minh City","Hanoi","Hoi An","Da Nang","Nha Trang"],
                    "Cambodia":["Siem Reap"],
                    "Myanmar":["Yangon","Bagan","Mandalay"],
                    "Nepal":["Kathmandu"],
                    "India":["Mumbai","Goa","New Delhi"]
                },
                Europe_MiddleEast: {
                    "United Kingdom":["London","Edinburgh","Liverpool","Bath","Glasgow","Oxford","York","Inverness"],
                    "France":["Paris","French Riviera", "Provence","Bordeaux","Lyon"],
                    "Netherlands":["Amsterdam"],
                    "Germany":["Berlin","Munich","Frankfurt","Hamburg","Cologne"],
                    "Austria":["Vienna","Salzburg"],
                    "Switzerland":["Zurich","Lucerne","Geneva"],
                    "Italy":["Puglia","Sicily","Florence","Venice","Naples","Verona"],
                    "Spain":["Canary Islands","Madrid","Barcelona","Andalusia","Malaga"],
                    "Iceland":["Reykjavik"],
                    "Finland":["Helsinki","Lapland"],
                    "Sweden":["Gothenburg"],
                    "Norway":["Oslo"],
                    "Denmark":["Copenhagen"],
                    "Greece":["Crete","Santorini","Thessaloniki","Athens"],
                    "Russia":["Moscow"],
                    "Ireland":["Dublin"],
                    "Portugal":["Porto District"],
                    "Hungary":["Budapest"],
                    "Belgium":["Brussels"],
                    "Czech Republic":["Prague"],
                    "Poland":["Gdansk","Krakow"],
                    "Ukraine":["Lviv"],
                    "Slovakia":["Bratislava"],
                    "United Arab Emirates":["Dubai","Abu Dhabi"],
                    "Oman":["Muscat"],
                    "Turkey":["Istanbul","Antalya","Cappadocia"],
                    "Israel":["Jerusalem"],
                },
                America:{
                    "United States":["Seattle","New York","Los Angeles","Orlando","San Francisco","Chicago","Las Vegas","Washington DC","Boston","Hawaii","Miami","Guam","San Diego"]
                },
                Africa_Oceania:{
                    "Australia":["Sydney","Melbourne","Cairns","Perth","Gold Coast","Uluru","Alice Springs","Adelaide","Darwin"],
                    "New Zealand":["Queenstown","Auckland"],
                    "South Africa":["Cape Town"],
                    "Mauritius":["Mauritius"],
                    "Morocco":["Marrakech"]
                }
            }
        },

        watch: {
            q: throttle(async function(e) {
                if(e && e !== "" && this.lastPredictiveSearchQ !== e && e !== this.search_keyword) {
                    let locale = "en-US";
                    if(this.locale === "zh-TW" || this.locale === "zh-CN" || this.locale === "zh-HK"){
                        locale = "zh-TW";
                    }
                    axios.post(window.location.protocol + "//" + this.apiDomain + "/api/v1/activities/l", {
                        q: e,
                        city: this.c
                    });
                    this.showPredictiveSearch = true;
                    this.lastPredictiveSearchQ = e;
                    this.predictiveSearchesResults = [];
                    const url = new URL(window.location.protocol + "//" + this.apiDomain + "/api/v1/activities/suggest");
                    const res = await axios.get(url + "?q=" + e + "&city=" + this.c + "&locale=" + locale);
                    if(res && res.data){
                        this.predictiveSearchesResults = res.data;
                        if(this.predictiveSearchesResults.length == 0){
                            this.showPredictiveSearch = false;
                        }
                    }
                }else{
                    this.showPredictiveSearch = false;
                }
            }, 1000),

            c: throttle(async function(e) {
                this.filteredCities = [];
                this.showNoPlace = false;
                if(e) {
                    let locale = "en-US";
                    if(this.locale === "zh-TW" || this.locale === "zh-HK" || this.locale == "zh"){
                        locale = "zh-HK";
                    }
                    const res = await axios.get(window.location.protocol + "//" + this.apiDomain + "/api/v1/country-city/?q=" + e, {
                        headers: {
                            "App-Locale": locale
                        }
                    });
                    if (res && res.data) {
                        this.filteredCities = res.data;
                        if (this.filteredCities.length == 0) {
                            this.showNoPlace = true;
                        }
                    }
                }
            }, 1000),
        },

        methods: {

            search(){
                this.city = '';
                if(this.showNoPlace || this.c === ""){
                    this.citySelector = false;
                    this.showCitiesInputBox = true;
                    return this.showNoPlace = true;
                }
                sessionStorage.city = this.c;
                const url = new URL(window.location.href = window.location.protocol + "//" + window.location.host + "/travel-activity");
                const paramString = new URLSearchParams({
                    city: this.c
                });
                if(this.q && this.q != ""){
                    paramString.append("q", this.q);
                }
                this.isLoading = true;
                window.location.href = url + "?" + paramString.toString();
            },

            selectCity(city_name){
                this.c = city_name;
                this.showCitiesInputBox = false;
                this.citySelector = false;
            },

            select(city_name){
                this.c = city_name;
                this.showCitiesInputBox = false;
            },

            selectContinent(continent){
                if (continent == 'asia') {
                    this.isAsiaActive = true;
                    this.isEuroActive = false;
                    this.isAmericaActive = false;
                    this.isAfricaActive = false;
                } else if (continent == 'euro'){
                    this.isAsiaActive = false;
                    this.isEuroActive = true;
                    this.isAmericaActive = false;
                    this.isAfricaActive = false;
                } else if (continent == 'america'){
                    this.isAsiaActive = false;
                    this.isEuroActive = false;
                    this.isAmericaActive = true;
                    this.isAfricaActive = false;
                } else if (continent == 'africa'){
                    this.isAsiaActive = false;
                    this.isEuroActive = false;
                    this.isAmericaActive = false;
                    this.isAfricaActive = true;
                }
            },

            keyDownCitySelector(){
                this.citySelector = true;
                this.showPredictiveSearch = false;
            },

            selectPredictiveSearch(predictiveSearch){
                this.q = predictiveSearch;
                this.showPredictiveSearch = false;
                this.predictiveSearchesResults = [];
            },

            cancelPredictiveSearch(e){
                setTimeout(() => {
                    e.target.blur();
                    this.showPredictiveSearch = false;
                }, 100);
            },

            resumePredictiveSearch(){
                if(this.predictiveSearchesResults && this.predictiveSearchesResults.length > 0) {
                    this.showPredictiveSearch = true;
                }
            },

            searchPopularSearch(city_name){
                sessionStorage.city = city_name;
                const url = new URL(window.location.href = window.location.protocol + "//" + window.location.host + "/travel-activity");
                const paramString = new URLSearchParams({
                    city: city_name
                });
                this.isLoading = true;
                window.location.href = url + "?" + paramString.toString();
            }

        },

        mounted() {
            // if (this.city === undefined || this.city === ''){
            //     if (sessionStorage.city){
            //         this.c = sessionStorage.city
            //     } else {
            //         this.c = ''
            //     }
            // } else {
            //     this.c = this.city;
            //     sessionStorage.city = this.c;
            // }

            if (this.city === undefined){
                this.city = '';
            }
            if (sessionStorage.city) {
                this.c = sessionStorage.city
            }
            if(this.city){
                this.c =  this.city;
            }
            this.q = this.search_keyword;
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";

    .search-container{

        .loader-container{
            padding: 32px;
            display: flex;
            justify-content: center;
        }

        .input:focus{
            border-color: #dbdbdb;
            box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);
        }

        .is_city_empty{
            color: #dbdbdb !important;

        }

        &.is-large{
            .input-container .control .input{
                padding: 32px 10px;
            }
            .input-container .search-button{
                height: 64px;
                padding: 0 32px;
            }

            @include responsive() {
                .input-container .country-select-container {
                    top: 62px;
                }

                .input-container .activity-select-container{
                    top: 126px;
                }
            }
        }

        .input-container{
            display: flex;
            margin: auto;
            position: relative;
            @include responsive(){
                display: block;
            }


            .control{
                .empty-city{
                    color: #999999 !important;
                }

                .input{
                    border: none;
                    box-shadow: none;
                    font-size: 16px;
                    padding: 22px 10px;
                    color: unset;

                    &::placeholder{
                        color: #999999;
                    }

                    &:hover{
                        border: none;
                    }
                }

                .icon{
                    color: #7a7a7a;
                    height: 100%;
                }

                .place-input{
                    border-radius: 0;
                    padding-left: 16px !important;
                }

                .activity-input{
                    border-radius: 0px 5px 5px 0px;
                    @include responsive(){
                        border-radius: 0 0 5px 5px;
                        margin-bottom: 24px;
                    }
                }

                &:first-child{
                    .place-input{
                        border-radius: 5px 0px 0px 5px;
                        border-right: 1px solid #dadada;
                        @include responsive(){
                            border-radius: 5px 5px 0px 0px;
                            border-bottom: 1px solid #dadada;
                            border-right: none;

                        }
                    }
                }
            }

            .place-input-container{
                width: 200px;
                @include responsive(){
                    width: 100%;
                }
            }

            .activity-input-container{
                width: 600px;
                @include responsive(){
                    width: 100%;
                }
            }

            .search-button{
                background: #59D876;
                border-radius: 5px;
                border-color: transparent;
                margin-left: .5rem;
                height: 44px;
                padding: 0 16px;

                @include responsive(){
                    width: 100%;
                    margin-left: 0;
                }

                &:hover{
                    color: #FFF;
                }

                i{
                    margin-right: 8px;
                    position: relative;
                    top: 1px;
                    @include responsive(){
                        display: none;
                    }
                }
            }

            .country-select-container{
                position: absolute;
                left: 0;
                top: 100%;
                width: 200px;
                max-height: 300px;
                overflow: hidden;
                z-index: 1;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                border-radius: 5px;
                margin-top: 4px;
                max-width: 600px;
                @include responsive(){
                    top: 41px;
                    width: 100%;
                }

                .scroll-container{
                    max-height: 300px;
                    overflow: auto;
                }

                ul{
                    li{
                        &:before {
                            display: none;
                        }
                        padding-left: 0;

                        a {
                            padding: 12px 16px;
                            text-align: left;
                            background-color: #FFF;
                            transition: all 0.25s;
                            color: #707070;
                            display: block;

                            i{
                                margin-right: 6px;
                            }

                            &:not(:last-child) {
                                border-bottom: 1px solid #DEDEDE;
                            }

                            &:hover {
                                color: #FFF;
                                background-color: #0176EE;
                            }
                        }

                        &.no-this-place-container{
                            padding: 40px 12px;
                            background: #FFF;
                        }
                    }
                }
            }
            .activity-select-container{
                position: absolute;
                left: 200px;
                top: 100%;
                width: 100%;
                max-height: 300px;
                overflow: hidden;
                z-index: 1;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                border-radius: 5px;
                margin-top: 4px;
                max-width: 600px;
                background: #FFF;

                @include responsive(){
                    top: 85px;
                    left: 0;
                }

                .scroll-container{
                    max-height: 300px;
                    overflow: auto;
                }

                ul{
                    .cancel-button-container{
                        text-align: end;
                        .fa-times-circle{
                            margin-right: 8px;
                            margin-top: 8px;
                        }
                    }
                    li{
                        background-color: #ffffff;
                        border-bottom: 1px solid #EEE;

                        &:before {
                            display: none;
                        }
                        padding-left: 0;

                        a {
                            padding: 12px 16px;
                            text-align: left;
                            background-color: #FFF;
                            transition: all 0.25s;
                            color: #707070;
                            display: block;

                            i{
                                margin-right: 6px;
                            }

                            &:not(:last-child) {
                                border-bottom: 1px solid #DEDEDE;
                            }

                            &:hover {
                                color: #FFF;
                                background-color: #0176EE;
                            }
                        }

                        &.no-this-place-container{
                            padding: 40px 12px;
                            background: #FFF;
                        }
                    }
                }
            }
        }
        .predictive-search-container {
            position: absolute;
            @include responsive(){
                position: fixed;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                z-index: 100;
            }

            .input-container {
                display:flex;
                align-items: center;
                @include responsive(){
                    width: 100%;
                    display: flex;
                    align-items: center;
                }
                input {
                    width: 88%;
                    height: 36px;
                    margin-left: 16px;
                    box-shadow: unset;
                    @include responsive(){
                        margin-left: 16px;
                        width: 82%;
                    }
                    &::placeholder{
                        color: #999999;
                    }
                }
                .fal{
                    font-size: 20px;
                }
                .icon-container{
                    /*width: 36px;*/
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 6px;
                    height: 36px;
                }
            }

            .is-active {
                border-bottom: 1px solid #000000 !important;
            }

            .section-title {
                margin-top: 12px;
                margin-bottom: 12px;
            }

            .country-select-container {
                width: 564px;
                max-height: 625px;
                overflow: hidden;
                z-index: 1;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
                border-radius: 8px;
                margin-top: 4px;
                background: white;

                @include responsive(){
                    margin-top: unset;
                    border-radius: unset;
                    width: 100%;
                    max-height: 100%;
                    height: 100%;
                }

                .scroll-container {
                    padding-top: 24px;
                    padding-bottom: 24px;
                    max-height: 624px;
                    overflow: auto;
                    @include responsive(){
                        max-height: 100%;
                    }

                    .popular-city {
                        padding-left: 16px;
                        padding-right: 16px;
                        .feature-cities-container{
                            display: flex;
                            flex-wrap: wrap;
                            a{
                                color: #000000;
                                /*&:hover{*/
                                /*    color: #0176EE;*/
                                /*}*/
                            }
                            .city {
                                border: 1px solid #D9DCDE;
                                min-height: 40px;
                                margin-right: 16px;
                                margin-bottom: 8px;
                                padding: 0 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                transition: all 0.1s ease-in-out;
                                &:hover{
                                    border: 1px solid #0176ee;
                                    color: #0176ee;
                                    cursor: pointer;
                                }
                            }
                        }
                    }

                    .image-container {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;

                        .popular-city-d {
                            position: relative;
                            margin-right: 8px;
                            margin-bottom: 4px;

                            img {
                                width: 124px;
                                height: 100%;
                                /*margin-right: 8px;*/
                            }

                            .gradient{
                                position: absolute;
                                top: 0;
                                height: 100%;
                                width: 100%;
                                background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
                                border-radius: 4px;
                            }

                            .word-container{
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }
                    }

                    .all-city {
                        padding-left: 16px;
                        padding-right: 16px;
                    }

                    .continent-container {
                        display: flex;
                        justify-content: center;
                        a{
                            color: #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            &:hover{
                                color: #0176EE;
                                border-bottom: 1px solid #0176ee !important;
                            }
                        }


                        .continent {
                            border-bottom: 1px solid #EEEEEE;
                            min-width: 25%;
                            text-align: center;
                            padding-top: 8px;
                            padding-bottom: 8px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }

                    .cities-container {
                        display: flex;
                        margin-top: 16px;

                        .country {
                            margin-right: 24px;
                            min-width: 70px;
                            width: 70px;
                            a{
                                color: #000000;

                                &:hover{
                                    color: #0176EE;
                                }
                            }
                        }

                        .cities {
                            display: flex;
                            flex-wrap: wrap;

                            a{
                                color: #000000;

                                &:hover{
                                    color: #0176EE;
                                }
                            }

                            .city {
                                margin-left: 24px;
                                margin-right: 24px;
                                margin-bottom: 4px;
                                @include responsive(){
                                    margin-left: unset;
                                }
                            }
                        }
                    }

                    .predictive-search {

                        .section-title{
                            padding-left: 16px;
                        }

                        ul {
                            li {
                                &:before {
                                    display: none;
                                }

                                padding-left: 0;

                                a {
                                    padding: 12px 16px;
                                    text-align: left;
                                    background-color: #FFF;
                                    transition: all 0.25s;
                                    color: #707070;
                                    display: block;

                                    i {
                                        margin-right: 6px;
                                    }

                                    &:not(:last-child) {
                                        border-bottom: 1px solid #DEDEDE;
                                    }

                                    &:hover {
                                        color: #FFF;
                                        background-color: #0176EE;
                                    }
                                }

                                &.no-this-place-container {
                                    padding: 40px 12px;
                                    background: #FFF;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .popular-search-container{
        display: flex;
        margin-top: 16px;
        @include responsive(){
            margin-top: 16px;
            display: block;
        }
            .popular-search{
            color: #FFFFFF;
        }
        .popular-search-cities{
            display: flex;
            flex-wrap: wrap;
        }
        a{
            margin-right: 12px;
            text-decoration: underline;
            color: #FFFFFF;
            &:hover{
                color: #FFFFFF;
                opacity: 0.7;
                transition:all 0.1s ease-in-out;
            }
        }
    }
</style>
